import { render } from "./ResearchItsInnovationComp.vue?vue&type=template&id=651d2018&scoped=true"
import script from "./ResearchItsInnovationComp.vue?vue&type=script&lang=js"
export * from "./ResearchItsInnovationComp.vue?vue&type=script&lang=js"

import "./ResearchItsInnovationComp.vue?vue&type=style&index=0&id=651d2018&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651d2018"]])

export default __exports__